import React, { useState } from "react";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What are KRC-20 tokens?",
      answer:
        "KRC-20 tokens are built on the Kaspa Network using the KasPlex protocol.",
    },
    {
      question: "How do you buy $KOON tokens?",
      answer:
        "Some popular KRC-20 tokens can be bought on centralized exchanges, while others – through the marketplaces.",
    },
    {
      question: "How are KRC-20 tokens created?",
      answer:
        "Kasplex employs the Pay-to-Script-Hash (P2SH) method to embed data into the Kaspa network, ensuring efficient data storage and avoiding UTXO bloat, thereby maintaining the network's scalability and longevity.",
    },
    {
      question: "What’s the difference between KRC-20 and other tokens?",
      answer:
        "The ERC-20 tokens are built on the Ethereum network and follow the ERC-20 token standard deployed using smart contracts. On the other hand, KRC-20 tokens are built on the Kaspa blockDAG and follow the KRC-20 token standard without the need for smart contracts.",
    },
    {
      question: "What is a memecoin?",
      answer:
        "A memecoin is a cryptocurrency created for fun and community engagement. While some see memecoins as jokes, they often create real-world value through their vibrant communities.",
    },
  ];

  return (
    <div id="faq" className="faq_container">
      {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#f5f5f5"
          fill-opacity="1"
          d="M0,128L80,128C160,128,320,128,480,133.3C640,139,800,149,960,133.3C1120,117,1280,75,1360,53.3L1440,32L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
        ></path>
      </svg> */}

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        className="donation_wave"
      >
        <path
          fill="#333333"
          fill-opacity="1"
          d="M0,192L80,176C160,160,320,128,480,128C640,128,800,160,960,165.3C1120,171,1280,149,1360,138.7L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
        ></path>
      </svg>

      <div className="title dark">
        <h1>Faq</h1>
        <img src="/images/claw_title.png" alt="Claw" className="claw-title" />
      </div>
      <div className="container mx-auto faq">
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <div
                className="faq-question"
                onClick={() => toggleAccordion(index)}
              >
                {faq.question}
                <span className="faq-toggle">
                  {activeIndex === index ? "-" : "+"}
                </span>
              </div>
              {activeIndex === index && (
                <div
                  className={`faq-answer ${
                    activeIndex === index ? "open" : ""
                  }`}
                >
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-center mt-12">
        <a
          href="https://t.me/kspr_home_bot?start=refresh"
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold button"
        >
          Buy $KOON
        </a>
      </div>
    </div>
  );
};

export default FAQ;
